type LocalStorageOutputs = {
  setItem: (value: string) => void;
  getItem: () => string | undefined;
  removeItem: () => void;
};

export const useLocalStorage = (key: string): LocalStorageOutputs => {
  const setItem = (value: string): void => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      throw new Error(`Failed to create value. ${error}`);
    }
  };

  const getItem = (): string | undefined => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : undefined;
    } catch (error) {
      throw new Error(`Failed to get value. ${error}`);
    }
  };

  const removeItem = (): void => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      throw new Error(`Failed to remove value. ${error}`);
    }
  };

  return { setItem, getItem, removeItem };
};
